export default __webpack_public_path__ + "static/media/1310.3a669159.png";